import PropTypes from 'prop-types';
export const columnsDetailsPropTypes = PropTypes.objectOf(PropTypes.shape({
    width: PropTypes.number,
    defaultWidth: PropTypes.number,
    maxWidth: PropTypes.number,
}));
